import React from 'react';
// Shared imports
import settings from '../../../settings';

const SignDefaultProps = {
    content: <></>,
    className: "",
    onClick: () => {},
    locked: false
};

function Sign(props = SignDefaultProps) {
    const { content, className, onClick, locked } = props;
    return (
        <div className={`gameguide-sign ${className}`}>
            <button 
                type="button" 
                onClick={onClick} 
                disabled={locked}
            >
                {content}
                {
                    locked
                    ? <img className="lock" src={`${settings.assetsPath}img/icons/lock.png`} alt="Locked" />
                    : <></>
                }
            </button>
            <span className="stick" />
        </div>
    );
}

export default Sign;